/**
 * 灰度配置 Key 常量
 * 统一管理所有灰度配置的 key，避免硬编码
 */

/**
 * 地址定位不准功能灰度配置
 * 支持JSON单维度格式：{"dspIds": [1,2,3]}
 * 支持多维度格式：{"driverIds": [16879], "dspIds": [250, 277]}
 */
export const GRAY_CONFIG_ADDRESS_COORDINATE_FEEDBACK = 'address.coordinate_feedback.gray_config';

/**
 * 导航地址标准化功能灰度配置
 * 支持JSON单维度格式：{"warehouseIds": [1,2,3]}
 * 支持多维度格式：{"warehouseIds": [1,2,3], "dspIds": [250, 277]}
 */
export const GRAY_CONFIG_NAVIGATION_ADDRESS_ANALYZE = 'navigation.address_analyze.gray_config';

/**
 * TMS 司机端拍照水印禁用开关
 * 启用后，TMS 司机上传照片时不添加水印，直接上传原图
 */
export const GRAY_CONFIG_TMS_DRIVER_PHOTO_WATERMARK_DISABLED = 'tms.driver.photo.watermark.disabled';

